export const StatusBanner = ({
  tone,
  title,
  message,
}: {
  tone: "success" | "error" | "neutral";
  title: string;
  message: string;
}) => {
  const tones = {
    success: "border-emerald-200 bg-emerald-50 text-emerald-900",
    error: "border-burgundy/30 bg-burgundy/5 text-burgundy",
    neutral: "border-stone-200 bg-stone-50 text-stone-800",
  };

  return (
    <div className={`rounded-sm border px-5 py-5 ${tones[tone]}`}>
      <h3 className="font-semibold text-lg">{title}</h3>
      <p className="mt-2 text-base leading-relaxed">{message}</p>
    </div>
  );
};
